import { perfMark } from "./utils/perf-tracker";
perfMark("app-start");

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./sass/main.scss";
import "react-day-picker/dist/style.css";

// React 19 - createRoot API
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar Service Worker para PWA (solo en producción)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado correctamente:', registration.scope);
      })
      .catch((error) => {
        console.log('Error al registrar Service Worker:', error);
      });
  });
}
